export enum VideojsTechEnum {
  HTML5 = 'html5',
  CHROMECAST = 'chromecast',
}
